__turbopack_context__.v({
  "paragraph": "io4qqa_paragraph",
  "wrapper": "io4qqa_wrapper",
});
